import React, { ReactNode } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import Loading from "../Components/Common/Loading";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }): React.ReactElement | null => {
  const { currentUser, loading } = useAuth();

  // Show loading while checking auth status
  if (loading) {
    return <Loading show={true} />;
  }

  /**
   * Go to login page if:
   * + No authenticated user
   * + User data fetched but no valid _id
  */
  if (!currentUser || !currentUser._id) {
    return <Navigate to="/login" />
  }

  /**
   * Redirect All protected page to account activate page if:
   * + Logged in, user status not activated
  */
  if (currentUser && currentUser.status !== 'activated') {
    return <Navigate to="/account/activate" />
  }

  // Continue the protect page if isAuthenticated
  return <>{children}</>;
}

export default ProtectedRoute;